<template>
  <a
    class="m-button"
    v-if="href !== undefined"
    :href="href"
    @click="$emit('click', $event)"
  >
    <slot></slot>
  </a>
  <button class="m-button" v-else @click="$emit('click')">
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    href: String
  }
};
</script>

<style scoped>
button,
a {
  border: 0;
  border: 1px solid;
  border-radius: 0;
  text-transform: uppercase;
  background-color: transparent;
  padding: 5px;
  text-decoration: none;
  font-size: 12px;
  font-family: monospace;
  color: black;
}
button:hover,
button:focus,
a:hover,
a:focus {
  background-color: black;
  border-color: black;
  color: white;
}
</style>
